import React from 'react';
// import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';

class BasicSwitch extends React.Component {
    state = {
        checked: false,
    };

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({checked: this.props.defaultValue});
        }
    }

    handleChange = (event) => {
        this.setState({checked: event.target.checked});
        this.props.onChange(this.props.title, event.target.checked);
    };

    render() {
        const {testid} = this.props;
        return (
            <div className="basic-switch">
                <Switch
                    classes={{
                        root: 'switch-root',
                        switchBase: 'switch-base',
                        checked: 'switch-checked',
                    }}
                    checked={this.state.checked}
                    onChange={this.handleChange}
                    value={this.state.checked}
                    inputProps={{
                        'aria-label': 'secondary checkbox',
                        'data-testid': testid ? testid : '',
                    }}
                />
            </div>
        );
    }
}

BasicSwitch.propTypes = {};
export default BasicSwitch;
